"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * https://webaim.org/techniques/css/invisiblecontent/
 * This is to hide an input to be replaced by a custom one.
 * The following are the recommended styles for visually hiding
 * content that will be read by a screen reader.
 */
var hideOffScreen = function hideOffScreen() {
  return "\n  height: 1px;\n  left: -10000px;\n  overflow: hidden;\n  position: absolute;\n  top: auto;\n  width: 1px;\n";
};
var _default = exports.default = hideOffScreen;